<template>
  <el-row class="note">
    <el-col :span="8" class="v-ml-10">
      {{ $route.meta.name }}
    </el-col>
  </el-row>
</template>
<script>
export default {
  name: 'CrmNote'
}
</script>
<style lang="stylus" scoped>
.note
  padding 0 15px 0 0
  height 30px
  line-height 30px
  display flex
  vertical-align: middle
</style>
